import { render, staticRenderFns } from "./exclusiveDetail.vue?vue&type=template&id=81ef91ee&scoped=true&"
import script from "./exclusiveDetail.vue?vue&type=script&lang=js&"
export * from "./exclusiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveDetail.vue?vue&type=style&index=0&id=81ef91ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ef91ee",
  null
  
)

export default component.exports